// extracted by mini-css-extract-plugin
export default {"description":"H5ossRAepHAmJGLOaopc","dialogBody":"pvaQjAGe968kvLLEYyoA","dialogFooter":"sooluxowW9jtpIJVGzny","error":"qhGXZzrpYeiZ11jEW7AX"};